import React from "react";
import { Button } from "react-bootstrap";

export default function ShowButton(props) {

    return (
        <React.Fragment>
            <Button className="btn btn-sm btn-success" title="Détails" onClick={props.action}>
                <i className="fas fa-list"></i></Button>
        </React.Fragment>
    )
}